var map = {
	"./c-1.png": "H1yy",
	"./c-2.png": "IB1n",
	"./c-3.png": "TMJV",
	"./c-4.png": "Ra20"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VuV4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1 ^\.\/c\-.*\.png$
// module id = VuV4
// module chunks = 1